/**
 * Sums all the properties in an object.
 *
 * @example monthlySpendingAverage = getSumOfObjectValues(monthlySpendingObject);
 *
 * @param {Object} theObject - an object with top-level properties that are numeric
 * @return {number} sum of numeric properties; 0 if no properties are numeric
 */
function getSumOfObjectValues(theObject) {
    return Object.values(theObject)
        .reduce((sum, val) => sum + (
            typeof val === 'number' && !Number.isNaN(val)
                ? val
                : 0
        ), 0);
}

export default getSumOfObjectValues;
